import axiosClient from "./axiosClient";

const eventCategoryApi = {
    getAll: () =>{
        const url = `api/eventCategory/getall`
        return axiosClient.get(url,{
            useAuthorize: true
        })
    },    
    getById: (params) =>{
        const url = `api/eventCategory/getbyid/${params}`
        return axiosClient.get(url,params)
    },
    getByEventCateId: (params,data) =>{
        const url = `api/eventCategory/${params}`
        return axiosClient.post(url,data)
    },

    updateById: (params,data) =>{
        const url = `api/eventCategory/${params}`
        return axiosClient.put(url,data, {
            useAuthorize: true
        })
    },
    create: (data) =>{
        const url = `api/eventCategory/create`
        // return axiosClient.post(url, data)
        return axiosClient.post(url, data, {
            useAuthorize: true
        })
    },
    delete: (params) =>{
        const url = `api/eventCategory/${params}`
        return axiosClient.delete(url, {
            useAuthorize: true
        })
    },

    getAdsEvent: (params, language) =>{
        const data = {    
            language: language,
            ads: true
        };
        const url = `api/eventCategory/getads/${params}`
        return axiosClient.post(url, data)
    },

}
export default eventCategoryApi;